import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "overflow-x-auto" };
const _hoisted_2 = { class: "w-full text-sm" };
const _hoisted_3 = { class: "border-b border-(--colors-border-base-soft)" };
const _hoisted_4 = { class: "text-left py-2 pr-4 font-medium text-(--colors-text-secondary)" };
const _hoisted_5 = { class: "text-left py-2 pr-4 font-medium text-(--colors-text-secondary)" };
const _hoisted_6 = { class: "text-left py-2 pr-4 font-medium text-(--colors-text-secondary)" };
const _hoisted_7 = { class: "text-left py-2 font-medium text-(--colors-text-secondary)" };
const _hoisted_8 = {
    key: 0,
    class: "border-b border-(--colors-border-base-soft) last:border-0"
};
const _hoisted_9 = {
    colspan: "4",
    class: "py-8 text-center text-(--colors-text-secondary)"
};
const _hoisted_10 = { class: "py-3 pr-4 text-(--colors-text-secondary)" };
const _hoisted_11 = { class: "py-3 pr-4 font-medium" };
const _hoisted_12 = { class: "py-3 pr-4 font-mono text-xs text-(--colors-text-secondary)" };
const _hoisted_13 = { class: "py-3" };
import { Badge, WidgetShell } from "@eudonet/opal";
import { useI18n } from "vue-i18n";
import { useFinanceFormatters } from "@/shared/composables/useFinanceFormatters";
import { donationStatusTheme, donationStatusIcon } from "../../composables/donationStatusBadge";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubscriptionTabPayments',
    props: {
        payments: {}
    },
    setup(__props) {
        const { t } = useI18n();
        const { formatAmount, formatDate } = useFinanceFormatters();
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(WidgetShell), {
                header: _ctx.$t('finance.subscriptions.detail.donationHistory')
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("table", _hoisted_2, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", _hoisted_3, [
                                    _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t("finance.subscriptions.detail.payments.colDate")), 1 /* TEXT */),
                                    _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t("finance.subscriptions.detail.payments.colAmount")), 1 /* TEXT */),
                                    _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("finance.subscriptions.detail.payments.colReference")), 1 /* TEXT */),
                                    _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("finance.subscriptions.detail.payments.colStatus")), 1 /* TEXT */)
                                ])
                            ]),
                            _createElementVNode("tbody", null, [
                                (__props.payments.length === 0)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                                        _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.$t("finance.subscriptions.detail.payments.empty")), 1 /* TEXT */)
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.payments, (payment) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: payment.id,
                                        class: "border-b border-(--colors-border-base-soft) last:border-0 hover:bg-(--colors-background-hover) transition-colors"
                                    }, [
                                        _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(formatDate)(payment.donationDate)), 1 /* TEXT */),
                                        _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(formatAmount)(payment.amount, payment.currency)), 1 /* TEXT */),
                                        _createElementVNode("td", _hoisted_12, _toDisplayString(payment.label || "–"), 1 /* TEXT */),
                                        _createElementVNode("td", _hoisted_13, [
                                            _createVNode(_unref(Badge), {
                                                label: _unref(t)(`finance.donations.status.${payment.status}`),
                                                theme: _unref(donationStatusTheme)[payment.status],
                                                "show-close-icon": false,
                                                size: "sm",
                                                "left-icon": _unref(donationStatusIcon)[payment.status]
                                            }, null, 8 /* PROPS */, ["label", "theme", "left-icon"])
                                        ])
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["header"]));
        };
    }
});
